/**
 * Registry of the cleanups that release data owned by the signed-in user.
 *
 * Modules that keep per-user state in memory register a cleanup when they are
 * loaded, and DestroyCookies runs them all when the session ends, so the
 * session code does not depend on every module that caches user data.
 */
const cleanups = new Set();

/**
 * Registers a cleanup to run when the session ends.
 *
 * @param {() => void} cleanup
 */
export const registerSessionCleanup = (cleanup) => {
  cleanups.add(cleanup);
};

/**
 * Runs every registered cleanup. A failing cleanup never stops the others nor
 * the end of the session.
 */
export const runSessionCleanups = () => {
  cleanups.forEach((cleanup) => {
    try {
      cleanup();
    } catch {
      /* The session must end even if a cleanup fails. */
    }
  });
};
